import React from 'react'

import { useSearchParam } from '../../../../hooks'
import { RoleAssignmentsTable } from './RoleAssignmentsTable'
import { Title } from './Title'

export const RoleAssignments: React.FC = () => {
  const [searchParam, setSearchParam] = useSearchParam('search')

  return (
    <>
      <Title
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
      />
      <RoleAssignmentsTable
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
      />
    </>
  )
}
